import React, { useState } from "react";
import { object, func } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import Button from "../../atoms/Button";
import ProfileHeadline from "../../atoms/ProfileHeadline";
import TextField from "../../atoms/TextField";
import PasswordField from "../../atoms/PasswordField";
import MessageView from "../../atoms/MessageView";
import PopupOverlay from "../PopupOverlay";

import { verifyEmailOtp, verifyEmail } from "../../helper/api";
import { setLoading } from "../../helper/actions";
import { validatePassword } from "../../utils/utils";

import "./change-password.m.css";

const ChangePassword = ({ member, setLoading, navigateToPage, publisherAttributes }) => {
  const [error, setError] = useState(null);
  const [otp, setOtp] = useState("");
  const [otpError, setOtpError] = useState(null);
  const [password, setPassword] = useState("");
  const [passwordError, setPasswordError] = useState(null);
  const [showPopUp, setShowPopUp] = useState(false);
  const [showResendPopUp, setShowResendPopUp] = useState(false);

  const onOtpChange = (e) => {
    // Regex expression to make sure it takes only numbers
    const re = /^[0-9\b]+$/;

    if (!e.target.value || re.test(e.target.value)) {
      setOtp(e.target.value);

      // If error is set remove it since data is changed
      if (otpError) {
        setOtpError(null);
      }
    }
  };

  const onPasswordChange = (e) => {
    setPassword(e.target.value);

    // If error is set remove it since data is changed
    if (passwordError) {
      setPasswordError(null);
    }
  };

  const validate = () => {
    let flag = false;

    if (!otp) {
      setOtpError("Please enter 6-digit verification code sent to your email");
      flag = true;
    }

    const pwdError = validatePassword(password);

    if (pwdError) {
      setPasswordError(pwdError);
      flag = true;
    }

    return flag;
  };

  const onSubmitClick = (e) => {
    e.preventDefault();

    setError(null);

    if (validate()) {
      // Validations failed
      return;
    }

    verifyEmailOtp(otp, member.id, password)
      .then(() => {
        setShowPopUp(true);
      })
      .catch((ex) => setError("invalid-user"));
  };

  const togglePopup = () => {
    setLoading(true);
    navigateToPage("/profile");
  };

  const changePasswordClick = () => {
    verifyEmail(member.email);
    setError(null);
    setShowResendPopUp(true);
  };

  const changePopupView = () => {
    setShowResendPopUp(false);
  };

  return (
    <div styleName={`container  ${publisherAttributes.lang}-container`}>
      <ProfileHeadline
        title="Change Password"
        type="change-password"
        arrowClick={() => navigateToPage("/profile")}
        lang={publisherAttributes.lang}
      />

      <div styleName="wrapper">
        <TextField
          value={otp}
          error={otpError}
          placeholder="Enter 6-digit verification code here"
          name="otp"
          maxLength="6"
          inputType="type2"
          onChange={onOtpChange}
        />

        <span styleName="message green-message">
          Please enter 6-digit verification code sent to {member.email} to reset your password.
        </span>

        <PasswordField
          value={password}
          error={passwordError}
          label="New Password *"
          name="new-password"
          onChange={onPasswordChange}
        />
        <span styleName="message">Use atleast 8 charcaters, mix of numbers & letters</span>

        {error !== "invalid-user" ? (
          <MessageView type="error" text={error} />
        ) : (
          <div styleName="error">
            Incorrect verification code. Please try again or{" "}
            <span styleName="resend-otp-link" onClick={changePasswordClick}>
              resend
            </span>
          </div>
        )}

        <span onClick={onSubmitClick}>
          <Button content="SAVE" buttonType="type4" />
        </span>

        {showPopUp && (
          <PopupOverlay
            lang={publisherAttributes.lang}
            onClickHandler={togglePopup}
            popupMessage="Your password has been updated"
          />
        )}

        {showResendPopUp && (
          <PopupOverlay
            lang={publisherAttributes.lang}
            popupMessage={`A 6-digit verification code has been sent to ${member.email}`}
            onClickHandler={changePopupView}
          />
        )}
      </div>
    </div>
  );
};

ChangePassword.propTypes = {
  member: object.isRequired,
  navigateToPage: func.isRequired,
  setLoading: func,
  publisherAttributes: object,
};

const mapStateToProps = (state) => ({
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
});

const mapDispatchToProps = (dispatch) => ({
  navigateToPage: (url) => global.app.navigateToPage(dispatch, url),
  setLoading: (isLoading) => dispatch(setLoading(isLoading)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ChangePassword);
